export const cardConfig = () => {
  return {
    root: {
      // shadow: 'var(--card-shadow)',
      borderRadius: 'var(--radius-l)',
      bodyPadding: '14px'
    }
  }
}

export const cardPt = () => {
  return {
    title: 'font-16-b',
    content: 'font-14-n'
  }
}
